export default __webpack_public_path__ + "static/treinamento-4a46c28e0665cf71ed6e2b7f32fd3111.jpeg";